import { Icon, Text, HStack, VStack } from '@genial/components';
import { Color, Spacing, Typography } from '@genial/design-tokens';
import { useBreakpointValue } from '@genial/utils';
import { Box, FlatList, IconButton } from 'native-base';
import React from 'react';
import { StyleSheet } from 'react-native';

import { InfoItem } from '../InfoItem';
import { PositionItemDetails } from '../PositionItemDetails';

import { PositionItemResponsiveProps } from '.';

const style = StyleSheet.create({
  columnWrapper: {
    flex: 1,
    justifyContent: 'space-between',
  },
  gap: {
    rowGap: 16,
  },
});

export const PositionItemTablet: React.FC<PositionItemResponsiveProps> = ({
  handleChangeIsOpened,
  isOpened,
  fundName,
  applicationDate,
  profitabilityPosition,
  quotaValue,
  totalQuota,
  totalApplication,
  iofValueTotal,
  totalGrossTotal,
  irValueTotal,
  netValueTotal,
  hasMultiplePositions,
  fundPositions,
}) => {
  const numColumns = useBreakpointValue({ base: 1, sm: 4 });
  const isMobile = useBreakpointValue({ base: true, sm: false });
  const items = [
    { label: 'Rent.', value: profitabilityPosition },
    { label: 'Cota', value: quotaValue },
    { label: 'Quantidade', value: totalQuota },
    { label: 'Valor  aplicado', value: totalApplication },
    { label: 'Valor Bruto', value: totalGrossTotal },
    { label: 'IR', value: irValueTotal },
    { label: 'IOF', value: iofValueTotal },
    { label: 'Valor líquido', value: netValueTotal },
  ];

  return (
    <VStack space={Spacing['inline.xxxs']}>
      <HStack alignItems="center" justifyContent="space-between" py={Spacing['inline.xxxs']}>
        <VStack space={Spacing['inline.quarck']}>
          <Text fontSize={Typography['fontsize.md']} variant={'semibold'} color={'neutral.black'}>
            Fundo
          </Text>
          <Text fontSize={Typography['fontsize.md']} variant={'regular'} color={'neutral.dark'}>
            {fundName}
          </Text>
        </VStack>
        <HStack alignItems={'center'} space={Spacing['inline.xxxs']}>
          {!isMobile && (
            <VStack space={Spacing['inline.quarck']}>
              <Text
                fontSize={Typography['fontsize.md']}
                variant={'semibold'}
                color={'neutral.black'}>
                Aplicação
              </Text>
              <Text fontSize={Typography['fontsize.md']} variant={'regular'} color={'neutral.dark'}>
                {applicationDate}
              </Text>
            </VStack>
          )}
          <IconButton
            p={0}
            onPress={handleChangeIsOpened}
            variant="unstyled"
            icon={
              <Icon
                testID="accordion-chevron-icon"
                name={isOpened ? 'ChevronUp' : 'ChevronDown'}
                size={'xs'}
                color={Color['neutral.dark']}
              />
            }
          />
        </HStack>
      </HStack>
      {isOpened && (
        <FlatList
          key={numColumns}
          data={items}
          numColumns={numColumns}
          style={style.gap}
          showsVerticalScrollIndicator={false}
          keyExtractor={(item, index) => `${item.value}-${index}`}
          {...(numColumns !== 1 && { columnWrapperStyle: style.columnWrapper })}
          renderItem={({ item }) => (
            <Box minW={'90px'} pb={Spacing['inline.xxxs']}>
              <InfoItem {...item} />
            </Box>
          )}
        />
      )}
      {isOpened && hasMultiplePositions && <PositionItemDetails fundPositions={fundPositions} />}
    </VStack>
  );
};
